// Configuration file for easy customization

export const config = {
  // Background image for public pages (login, subscribe, support, etc.)
  // Replace this URL with your own image
  backgroundImage: 'https://daily-obx-cdn.b-cdn.net/newsletter-images/2026-OBXBB-2022-07-20-8043-Edit-Edit-Edit-Edit.jpg',
  
  // You can add more customization options here
  brandName: 'theobxbeachbum',
  tagline: 'Mostly Good OBX Beach Photography'
};
